import { render, staticRenderFns } from "./application-submitted.component.vue?vue&type=template&id=a989c776"
import script from "./application-submitted.component.ts?vue&type=script&lang=ts&external"
export * from "./application-submitted.component.ts?vue&type=script&lang=ts&external"
import style0 from "./application-submitted.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports